import { createSlice } from "@reduxjs/toolkit";
import { getUserDetailsFromEmail } from "../actions/adminUserManagement.action";
import { InitialState } from "../interfaces/userManagement.interface";

const initialState: InitialState = {
  isLoading: false,
  data: null,
};

const getUsersDetailsFromEmail = createSlice({
  name: "Get User Details from Email",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getUserDetailsFromEmail.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(getUserDetailsFromEmail.fulfilled, (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    });

    builder.addCase(getUserDetailsFromEmail.rejected, (state) => {
      state.isLoading = false;
    });
  },
});

export default getUsersDetailsFromEmail.reducer;
